import React, { useContext, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom';
import { serverInfo } from '../../App';
import Navigation from '../Layouts/Header/Navigation';
import axios from "axios";

function SSLCommerzPay() {
    const { shurjoFrormData, setShurjoFrormData } = useContext(serverInfo);
    const location = useLocation();
    let history = useHistory()
    const { state } = location



    console.log(state)

    const [msg, setMsg] = useState();
    useEffect(() => {
        window.addEventListener("message", (ev) => {
            setMsg(ev.data.message);
            if (ev.data.message == 'go-back') {
                history.push("/");

            }
        })


    }, []);




    return (




        <>
            {/* <p>{state.url}</p> */}
            <Navigation totalNotification={0} />
            <div className="h-100 d-flex justify-content-center">
                <iframe src={state.url} title="Iframe Example" style={{
                    display: 'block',
                    border: 'none',
                    height: 700,
                    width: '100vw',
                }}></iframe>
            </div>

        </>
    )
}

export default SSLCommerzPay
